const layout = {
  page: {
    mt: 4,
    mb: 4,
    maxWidth: "lg",
  },

  form: {
    maxWidth: "md",
  },

  section: {
    mt: 3,
    mb: 3,
  },

  card: {
    borderRadius: 4,
    p: 3,
  },

  footer: {
    minHeight: 80,
  },
};

export default layout;
